import React from 'react';
import styled from '@emotion/styled';
import {
	ArrowLinkButton,
	ButtonWrap,
	CallLinkButton,
	ICallToActionLink,
	StyledCallToAction,
} from '../../../ui';
import { CallToAction } from '../../shared/components';

const CallToActionWrap = styled.div`
	${StyledCallToAction} + ${StyledCallToAction} {
		margin-top: 20px;
		margin-bottom: 20px;
	}
`;

const links: ICallToActionLink[] = [
	{
		type: 'internal-link',
		key: 'contact-us',
		title: 'Contact us',
		url: '#',
	},
	{
		type: 'phone-link',
		key: 'call-us',
		title: 'Call us',
		number: '+1-123-456-7890',
	},
];

export const CallToActions = () => (
	<CallToActionWrap>
		<h2 id="call-to-action">Call-To-Actions</h2>

		<CallToAction
			title='Call to action with theme "grey"'
			callToActionTheme="grey"
			links={links}
		/>

		<CallToAction
			title='Call to action with theme "blue-blue"'
			callToActionTheme="blue-blue"
			links={links}
		/>

		<CallToAction
			title='Call to action with theme "purple-blue"'
			callToActionTheme="purple-blue"
			links={links}
		/>

		<CallToAction
			title='Call to action with theme "green-blue"'
			callToActionTheme="green-blue"
			links={links}
		/>

		<StyledCallToAction>
			<h3>Call-To-Action header text with custom buttons</h3>
			<ButtonWrap>
				<ArrowLinkButton href="#">
					Button with a very very very very long title
				</ArrowLinkButton>
				<CallLinkButton secondary number="+1-123-456-7890">
					Call us
				</CallLinkButton>
			</ButtonWrap>
		</StyledCallToAction>

		<StyledCallToAction inverted>
			<h3>Inverted Call-To-Action with custom buttons</h3>
			<ButtonWrap>
				<ArrowLinkButton inverted href="#">
					Button with a very very very very long title
				</ArrowLinkButton>
				<CallLinkButton inverted secondary number="+1-123-456-7890">
					Call us
				</CallLinkButton>
			</ButtonWrap>
		</StyledCallToAction>
	</CallToActionWrap>
);
